// import { baseUrl } from '../config'
import axios from 'axios'
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/api' : ''
axios.defaults.timeout = 1000 * 120
// 配置请求库的debug拦截器
axios.interceptors.request.use(function (config) {
  if (config.method.toUpperCase() === 'OPTIONS') {
    config.withCredentials = false
  }
  return config
}, function (error) {
  // 请求错误时做些事
  return Promise.reject(error)
})

export default axios
